import React from "react";
import { SelectContainer } from "./style";
import { FiChevronDown } from "react-icons/fi";
const Select = ({
  name,
  onChange,
  value,
  label,
  ltr,
  error,
  options,
  required,
}) => {
  return (
    <SelectContainer ltr={ltr} error={error} required={required}>
      <label>{label}</label>
      <div className="select-area">
        <select
          name={name}
          onChange={onChange}
          defaultValue={value ? value : ""}
        >
          <option value="">انتخاب کنید</option>
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.title}
            </option>
          ))}
        </select>
        <FiChevronDown />
        <span className="error">{error}</span>
      </div>
    </SelectContainer>
  );
};
export default Select;
